import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ActionCard from '../../components/action-card';
import Spinner from '../../components/spinner';
import HttpError from '../../components/http-error';
import withAPI from '../../hocs/with-api';
import '../../date-picker.css';
import 'react-datepicker/dist/react-datepicker.css';
import Table from '../../components/table';

import IssueTableRow from '../../components/issue-table-row';
import FlashMessage from '../../components/flash-message';
import Pagination, { getCurrentPageNumber } from '../../components/pagination';

class IssuesOrders extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      issueOrdersList: [],
      currentPage: getCurrentPageNumber(props),
    };
  }

  async componentDidMount() {
    window.onpopstate = this.onBackButtonClick;
    this.loadOrdersIssues();
  }

  loadOrdersIssues = async () => {
    const { httpRequest } = this.props;

    const {
      currentPage,
    } = this.state;

    const params = {
      page: currentPage,
    };

    const response = await httpRequest({
      method: 'get',
      url: '/system/integrity/check-orders',
      data: { params },
    });

    if (response) {
      const {
        data: issues,
      } = response;
      this.setState({
        totalPages: response?.data?.meta?.totalPages,
        totalRecords: response?.data?.meta?.totalRecords,
        perPage: response?.data?.meta?.perPage,
        from: response?.data?.meta?.from,
        to: response?.data?.meta?.to,
      });
      this.parseIssues(issues);
    }
  }

  parseIssues = (response) => {
    const subjects = _.get(response, 'subjects', {});
    const issueOrdersList = _.reduce(subjects, (result, value, key) => {
      _.map(value.messages, (msg) => {
        if (value.status !== 'OK') {
          result.push({
            status: msg.type ? msg.type : value.status,
            path: key,
            message: _.get(msg, 'message', msg),
            objectId: _.get(msg, 'object_id', undefined),
            label: value.label,
          });
        }
      });
      return result;
    }, []);

    this.setState({
      issueOrdersList,
    });
  }

  handlePageChange = (currentPage) => {
    const { history } = this.props;
    this.setState(
      {
        currentPage,
      },
      () => {
        history.push(`/issues-orders/${currentPage}`);
        this.loadOrdersIssues();
      },
    );
  };

  onBackButtonClick = () => {
    const page = getCurrentPageNumber(this.props);
    this.setState({
      currentPage: page,
    }, this.loadOrdersIssues);
  }

  render() {
    const {
      t,
      httpGetDone,
      httpGetLoading,
      httpGetFailed,
    } = this.props;
    const {
      issueOrdersList,
      totalPages,
      currentPage,
      perPage,
      totalRecords,
      from,
      to,
    } = this.state;

    return (
      <>
        <ActionCard
          title={t('issues.title')}
          withActionButton={false}
        >
          {
            httpGetLoading && <Spinner marginTop="555px" />
          }
          {
            <FlashMessage />
          }
          {
            httpGetFailed && (
            <HttpError
              withTryAgainButton
              onTryAgain={this.loadKPI}
            />
            )
          }
          { !httpGetLoading && !httpGetFailed && httpGetDone && (
            <>
              <Table
                hover
                responsive="sm"
                size="sm"
                isEmpty={_.isEmpty(issueOrdersList)}
                emptyMessage={t('messages.noData')}
              >
                <thead>
                  <tr>
                    <th>{t('status')}</th>
                    <th>{t('messages')}</th>
                    <th className="text-right pr-4">{t('actions')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    _.map(issueOrdersList, (issue, index) => <IssueTableRow key={index} t={t} issue={issue} />)
                 }
                </tbody>
              </Table>
                {totalPages && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onChange={this.handlePageChange}
                  totalRecords={totalRecords}
                  perPage={perPage}
                  from={from}
                  to={to}
                />
                )}
            </>
          )}
        </ActionCard>
      </>
    );
  }
}

IssuesOrders.propTypes = {
  t: PropTypes.func.isRequired,
  httpRequest: PropTypes.func.isRequired,
  httpGetDone: PropTypes.bool.isRequired,
  httpGetLoading: PropTypes.bool,
  httpGetFailed: PropTypes.bool,
  history: PropTypes.object.isRequired,
};

IssuesOrders.defaultProps = {
  httpGetLoading: true,
  httpGetFailed: false,
};


export default compose(
  withTranslation(),
  withAPI,
  withRouter,
)(IssuesOrders);
